export type IframeReadyMetric = {
  name: string;
  value: number;
};

// Set by the host (web-fe-cashier)
export const HOST_METRICS_PARAMS = {
  startedAt: 'cashier_started_at',
  urlDuration: 'url_duration',
} as const;

export interface BuildIframeReadyMetricsParams {
  readyAt: number | null;
  /** `readyAt` in epoch ms, comparable with the host's `Date.now()` */
  readyAtEpoch: number;
  initDuration?: number;
  metricsParam?: string;
  sessionId: string;
  hostStartedAt?: string;
  urlDuration?: string;
}

// Above this: clock skew or a suspended page
const MAX_WIDGET_READY = 60_000;

const toPositiveNumber = (value?: string) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};

export const buildIframeReadyMetrics = ({
  readyAt,
  readyAtEpoch,
  initDuration,
  metricsParam,
  sessionId,
  hostStartedAt,
  urlDuration,
}: BuildIframeReadyMetricsParams): IframeReadyMetric[] | null => {
  if (metricsParam !== '1' || !sessionId) return null;
  if (!readyAt || readyAt < 0) return null;

  const metrics: IframeReadyMetric[] = [];

  // Host mount → ready
  const startedAt = toPositiveNumber(hostStartedAt);
  const widgetReady = startedAt === undefined ? undefined : readyAtEpoch - startedAt;

  if (widgetReady !== undefined && widgetReady > 0 && widgetReady <= MAX_WIDGET_READY) {
    metrics.push({
      name: 'legacy_cashier_widget_ready',
      value: Math.round(widgetReady),
    });
  }

  if (initDuration) {
    metrics.push({
      name: 'legacy_init_duration',
      value: Math.round(initDuration),
    });
  }

  const hostUrlDuration = toPositiveNumber(urlDuration);

  if (hostUrlDuration !== undefined) {
    metrics.push({
      name: 'legacy_url_duration',
      value: Math.round(hostUrlDuration),
    });
  }

  return metrics.length ? metrics : null;
};
